<template>
    <div class="newsletter">
        <h3 v-if="title">برای سرمایه گذاری‌های جدید خبرم کن</h3>
        <div class="flex center vcenter">
            <input type="mobile" placeholder="شماره همراه" v-model="models['receptor']">
            <button @click.prevent="newsletter()" :disabled="disabled">عضویت در خبرنامه</button>
        </div>
        <Social></Social>
    </div>
</template>

<script>
/* eslint-disable */
import Social from '../components/Social.vue'

export default {
    name: 'Newsletter',
    props: ['title'],
    inject: ['base'],
    components: { Social },
    data() {
        return {
            models: {
                receptor: ''
            },
            error: true,
            disabled: false,
        }
    },
    watch: {
        models: {
            handler(newModels, oldModels) {
                this.models['receptor'] = this.base.Util().locale(this.models['receptor'])
                this.error = this.models['receptor'] !== '' && !(
                    (['0900', '0901', '0902', '0903', '0904', '0905'
                        , '0910', '0911', '0912', '0913', '0914', '0915', '0916'
                        , '0917', '0918', '0919', '0990', '0991', '0992', '0993'
                        , '0994', '0996', '0930', '0933', '0935', '0936', '0937'
                        , '0938', '0939', '0941', '0920', '0921', '0922', '0923', '0998'
                        , '0999'].includes(this.models['receptor'].slice(0, 4)))
                    && this.models['receptor'].length === 11)
            },
            deep: true
        }
    },
    methods: {
        newsletter() {
            this.disabled = true
            this.$emit('onloading', true)
            if (!this.error && this.base.Util().validate(this.models['receptor']))
                this.base.API().post('Supplement/Newsletter/Register', {
                    data: [{ receptor: this.models['receptor'] }]
                }, (response) => {
                    this.$emit('onloading', false)
                    if (this.base.Util().success(response)) {
                        if (this.base.Util().validate(response.data.data))
                            this.base.Notification().toast('نتیجه عملیات', 'عضویت شما در خبرنامه آتیه ایرانیان باموفقیت انجام گردید!', 'success')
                    } else
                        this.base.Notification().error({
                            code: response.data.errorCode,
                            referr: 'newsletter'
                        })
                    this.disabled = false
                    this.models['receptor'] = ''
                }, (error) => {
                    this.disabled = false
                    this.$emit('onloading', false)
                    this.models['receptor'] = ''

                    this.base.Notification().error({
                        code: 5000,
                        text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                    })
                })
            else {
                this.disabled = false
                this.$emit('onloading', false)
                this.base.Notification().error({
                    code: 5000,
                    text: 'فرمت شماره همراه وارد شده صحیح نمی‌باشد.'
                })
            }
        }
    }
}
</script>

<style scoped src="../assets/css/components/newsletter.css"></style>